import React from 'react';
import Header from '../components/Header';
import HeroSection from '../components/HeroSection';
import AboutSection from '../components/AboutSection';
import FounderSection from '../components/FounderSection';
import MissionSection from '../components/MissionSection';
import ScanningSection from '../components/ScanningSection';
import CrystalCombinationsSection from '../components/CrystalCombinationsSection';
import BookingSection from '../components/BookingSection';
import DisclaimerSection from '../components/DisclaimerSection';
import Footer from '../components/Footer';

const HomePage = () => {
  return (
    <div className="min-h-screen bg-[#FFFEF8]">
      <Header />
      <main>
        <HeroSection />
        <AboutSection />
        <FounderSection />
        <MissionSection />
        <ScanningSection />
        <CrystalCombinationsSection />
        <BookingSection />
        <DisclaimerSection />
      </main>
      <Footer />
    </div>
  );
};

export default HomePage;
